import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import _toInteger from 'lodash/toInteger';
import { FlightEventReportDataProvider } from '../../core/context/FlightEventReportDataContext';
import { FlightEventFieldOptionsProvider } from '../../core/context/FlightEventFieldOptionsContext';
import { AuthorizationRequestType } from '../../core/api/clients';

function FlightEventFormLayout() {
  const { formId } = useParams<'formId'>();
  const { action } = useParams<'action'>();

  let requestType = AuthorizationRequestType.Contribute;
  if (action === 'approve') {
    requestType = AuthorizationRequestType.Approve;
  } else if (action === 'read') {
    requestType = AuthorizationRequestType.Read;
  } else if (action === 'view') {
    requestType = AuthorizationRequestType.View;
  }

  return (
    <div>
      <FlightEventReportDataProvider flightEventReportId={_toInteger(formId)} role={requestType}>
        <FlightEventFieldOptionsProvider>
          <Outlet />
        </FlightEventFieldOptionsProvider>
      </FlightEventReportDataProvider>
    </div>
  );
}

export default FlightEventFormLayout;
